const toDefault = decimal => decimal ?? 2

export const formatDecimalNumber = (value, decimal) =>
  value.toLocaleString(navigator.language, { minimumFractionDigits: toDefault(decimal), maximumFractionDigits: toDefault(decimal) })

export const formatRoundedNumber = value => value.toLocaleString(navigator.language, { minimumFractionDigits: 0, maximumFractionDigits: 0 })

export const sum = (a, b) => a + b
